// extracted by mini-css-extract-plugin
export default {"editorSettings":"editorSettings__aJvy3s","section":"section__XYTogl","slider":"slider__GR4qdJ"};